module.exports = {"brand":"Flight by Canto Wordpress Plugin","leftLinks":[],"rightLinks":[{"label":"Home","link":"/home","view":"home","isRouteBtn":true},{"label":"Protected","link":"/protected","view":"protected","isRouteBtn":true},{"label":"Foo","link":"/foo","view":"foo","isRouteBtn":true},{"label":"Images","link":"/images","view":"images","isRouteBtn":true},{"label":"Disconnect","link":"/login","view":"login","isRouteBtn":true}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/config/navigation.json
// module id = 614
// module chunks = 0